import { render, staticRenderFns } from "./AddContact.component.vue?vue&type=template&id=616108e0&scoped=true&"
import script from "./AddContact.component.vue?vue&type=script&lang=js&"
export * from "./AddContact.component.vue?vue&type=script&lang=js&"
import style0 from "./AddContact.component.vue?vue&type=style&index=0&id=616108e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616108e0",
  null
  
)

export default component.exports